<template>
  <li class="dropdown notifications-menu">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
      <i class="fa fa-warning"></i>
      <span class="label label-warning">{{ filterBy(filterBy(registros, true, 'is_alarme'), 1, 'valor') | count  }}</span>
    </a>
    <ul class="dropdown-menu">
      <li class="header">
        <div class="row no-margin">
          <span class="col-xs-12 col-md-6 tab-link" v-for="registro in  filterBy(filterBy(registros, true, 'is_alarme'), 1, 'valor')">
            <i class="fa fa-warning" v-if="flag === 'es'"> {{registro.labelEs}}</i>
            <i class="fa fa-warning" v-else-if="flag === 'de'"> {{registro.labelDe}}</i>
            <i class="fa fa-warning" v-else-if="flag === 'us'"> {{registro.labelEn}}</i>
            <i class="fa fa-warning" v-else> {{registro.labelPtBr}}</i>
            </span>
        </div>
      </li>
      <li>
        <ul v-if="tab === 'old'" class="menu">
          <notification-item v-for="notification in filterBy(filterBy(registros, true, 'is_alarme'), 1, 'valor')" :key="notification.id" :notification="notification"></notification-item>
          <li v-if="!oldNotifications.length">
            <span class="center-block text-center">Não existe nenhum alerta/alarme</span>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import NotificationItem from './NotificationItem'
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'

var db = firebaseApp.database()
var sd022020Ref = db.ref('sd022020')

export default {
  name: 'NotificationsMenu',
  components: {
    NotificationItem
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      tab: 'new',
      registros: []
    }
  },
  firebase: {
    registros: sd022020Ref
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    flag () {
      return this.$store.state.flag
    },
    newNotifications() {
      return this.userInfo.notifications.filter(n => !n.readAt)
    },
    oldNotifications() {
      return this.userInfo.notifications.filter(n => n.readAt)
    }
  },
  methods: {
    markAllAsRead() {
      event.stopPropagation()
      this.userInfo.notifications.filter(n => !n.readAt).forEach(function(notification) {
        notification.readAt = new Date().toUTCString
      })
    },
    switchTab(event, tab) {
      event.stopPropagation()
      this.tab = tab
    }
  }
}
</script>

<style scoped>
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu {
  width: 400px;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header {
  padding: 0;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span.tab-link {
  padding: 4px;
  text-align: center;
  cursor: pointer;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span.tab-link a {
  color: #444;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span.tab-link.active {
  font-weight: bold;
  border-bottom: 2px solid #3c8dbc;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span:hover.tab-link > a {
  color: #3c8dbc !important;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li > ul.menu {
  max-height: 300px;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li > ul.menu li > span {
  padding: 10px;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li:hover.footer > a {
  color: #3c8dbc !important;
}
</style>



// WEBPACK FOOTER //
// NotificationsMenu.vue?05049f04